import reduce from "./reduce.js";
function reduceLazy(f, seed) {
    if (seed === undefined) {
        return (iterable) => reduce(f, iterable);
    }
    return (iterable) => reduce(f, seed, iterable);
}
export default reduceLazy;
//# sourceMappingURL=reduceLazy.js.map